export default {
  "nav.brand": "USFANSLINK",
  "nav.home": "Strona główna",
  "nav.guide": "Pełny przewodnik",
  "nav.shoppingGuide": "Przewodnik zakupowy",
  "nav.visitMain": "Odwiedź stronę główną",

  "hero.eyebrow": "Zasób arkusza USFANS",
  "hero.title": "Arkusz USFANS — znajdź produkty, sprzedawców i zasoby zakupowe szybciej",
  "hero.subtitle": "Szukasz arkusza USFANS? Poznaj uporządkowane zasoby produktów, informacje o sprzedawcach, poradniki zakupowe, wskazówki dotyczące kontroli jakości, informacje o wysyłce, zasoby magazynowe i najnowsze aktualizacje USFANS — wszystko w jednym miejscu.",
  "hero.ctaPrimary": "usfans spreadsheet",
  "hero.ctaSecondary": "buy it now",
  "hero.trust": "Niezależny zasób informacyjny • Regularnie aktualizowany • Stworzony, by ułatwić wyszukiwanie produktów",

  "dropdown.label": "Przeglądaj kategorie",
  "dropdown.placeholder": "Wybierz kategorię…",

  "categories.title": "Zakupy według kategorii",
  "categories.subtitle": "Przejdź od razu do dowolnej kategorii produktów na stronie głównej. Każdy link otwiera się w nowej karcie.",
  "categories.shoes": "Buty",
  "categories.hoodies": "Bluzy / Swetry",
  "categories.tshirts": "Koszulki",
  "categories.jackets": "Kurtki",
  "categories.pants": "Spodnie / Szorty",
  "categories.headwear": "Nakrycia głowy",
  "categories.sets": "Zestawy",
  "categories.underwear": "Bielizna / Bokserki",
  "categories.jersey": "Koszulki sportowe",
  "categories.accessories": "Akcesoria",
  "categories.bags": "Torby",
  "categories.belts": "Paski",
  "categories.perfumes": "Perfumy",
  "categories.other": "Inne rzeczy",
  "categories.open": "Otwórz",

  "features.title": "Wszystko, czego potrzebujesz, aby poruszać się po arkuszu USFANS",
  "features.subtitle": "Uporządkowany zasób, który pomaga przejść od przeglądania do pewnej decyzji.",
  "features.f1.title": "Znajdź produkty szybciej",
  "features.f1.text": "Odkrywaj uporządkowane zasoby produktów i kategorii bez tracenia czasu na przeszukiwanie rozproszonych informacji.",
  "features.f2.title": "Porównuj sprzedawców",
  "features.f2.text": "Dowiedz się, co sprawdzać przy ocenie sprzedawców, informacji o produktach i dostępnych zasobów.",
  "features.f3.title": "Zrozum wysyłkę",
  "features.f3.text": "Poznaj informacje o wysyłce USFANS, koszty, metody i ważne kwestie przed złożeniem zamówienia.",
  "features.f4.title": "Sprawdź przed zakupem",
  "features.f4.text": "Korzystaj z poradników dotyczących kontroli jakości, magazynu, bezpieczeństwa i zakupów, aby podejmować lepsze decyzje.",

  "teaser.eyebrow": "Wyróżniony przewodnik",
  "teaser.title": "Kompletny przewodnik po arkuszu USFANS",
  "teaser.text": "Dowiedz się, czym jest arkusz USFANS, jak go używać i co sprawdzić przed zakupem — od badania sprzedawców po wysyłkę, kontrolę jakości i bezpieczeństwo.",
  "teaser.cta": "Przeczytaj pełny przewodnik",

  "faq.title": "FAQ arkusza USFANS",
  "faq.q1": "Czym jest arkusz USFANS?",
  "faq.a1": "To uporządkowany zasób, który grupuje kategorie produktów, notatki o sprzedawcach i informacje zakupowe w jedną ustrukturyzowaną listę, dzięki czemu szybciej przeglądasz produkty zamiast szukać strona po stronie.",
  "faq.q2": "Jak używać arkusza USFANS?",
  "faq.a2": "Zacznij od potrzebnej kategorii, przeczytaj notatki o sprzedawcy, porównaj kilka opcji, sprawdź wysyłkę, a następnie otwórz link do produktu w nowej karcie, aby kontynuować na stronie głównej.",
  "faq.q3": "Czy USFANS jest legalny?",
  "faq.a3": "Jesteśmy niezależnym zasobem i nie możemy zweryfikować każdego sprzedawcy ani produktu. Zawsze sprawdzaj aktualne informacje, opinie i warunki wysyłki przed zakupem.",
  "faq.q4": "Ile kosztuje wysyłka USFANS?",
  "faq.a4": "Koszty wysyłki zmieniają się w zależności od miejsca docelowego, wagi i metody, więc nie publikujemy tu stałych cen. Sprawdź aktualne informacje o wysyłce na stronie głównej przed zamówieniem.",

  "cta.title": "Gotowy, by poznać arkusz USFANS?",
  "cta.text": "Zacznij od centrum arkusza, poznaj najnowsze przewodniki i porównaj przydatne zasoby przed odwiedzeniem strony głównej.",
  "cta.primary": "Poznaj arkusz USFANS",
  "cta.secondary": "Przeczytaj przewodnik",

  "footer.disclaimerTitle": "Zastrzeżenie",
  "footer.disclaimer": "Ta strona jest niezależnym zasobem informacyjnym. Nie gwarantujemy sprzedawców, produktów, wyników wysyłki, zwrotów, transakcji ani terminów dostawy. Zawsze weryfikuj aktualne informacje przed zakupem.",
  "footer.explore": "Przeglądaj",
  "footer.company": "Firma",
  "footer.guide": "Pełny przewodnik",
  "footer.rights": "Wszelkie prawa zastrzeżone.",
  "footer.language": "Język",

  "guides.title": "Przewodniki i zasoby USFANS",
  "guides.subtitle": "Niezależne, oryginalne przewodniki, które pomogą Ci badać produkty, porównywać sprzedawców i kupować z pewnością.",
  "guides.readMore": "Przeczytaj przewodnik",
  "article.notFound": "Nie znaleziono przewodnika",

  "nav.about": "O nas",
  "nav.contact": "Kontakt",
  "nav.privacy": "Polityka prywatności",
  "nav.editorial": "Polityka redakcyjna",

  "contact.title": "Skontaktuj się z nami",
  "contact.subtitle": "Masz pytanie lub opinię? Wyślij nam wiadomość, a my odpowiemy.",
  "contact.name": "Imię",
  "contact.email": "E-mail",
  "contact.message": "Wiadomość",
  "contact.submit": "Wyślij wiadomość",
  "contact.sending": "Wysyłanie...",
  "contact.success": "Dziękujemy! Twoja wiadomość została wysłana.",
  "contact.error": "Coś poszło nie tak. Spróbuj ponownie.",

  "article.reviewedBy": "Recenzował",
  "article.lastUpdated": "Ostatnia aktualizacja",

  "notFound.title": "Nie znaleziono strony",
  "notFound.text": "Strona, której szukasz, nie istnieje lub została przeniesiona.",
};